const Table = ({children}) => {
    return (
        <table className="table-auto">
            {children}
        </table>
    )
}

export default Table;